export default "__VITE_ASSET__c4393b3e__"